import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import styles from './RuleListItem.module.scss';

export default function RuleListItem({
  isValidating,
  ruleKey,
  text,
  validationPassed,
}) {
  return (
    <li
      className={classnames(styles.listItem, {
        [styles.valid]: !isValidating && validationPassed,
        [styles.invalid]: !isValidating && !validationPassed,
        [styles.loading]: isValidating,
      })}
      data-testid={`passwordValidationList_${ruleKey}_${
        validationPassed ? 'valid' : 'invalid'
      }`}
    >
      {text}
    </li>
  );
}

RuleListItem.propTypes = {
  isValidating: PropTypes.bool.isRequired,
  ruleKey: PropTypes.string.isRequired,
  text: PropTypes.string,
  validationPassed: PropTypes.bool.isRequired,
};

RuleListItem.defaultValue = {
  text: '',
};
